import { faHeadphones } from "@fortawesome/free-solid-svg-icons";
import { ListarHistoricoLigacoesController } from "../../../../Controllers/Geral/ContaLigacao/ContaLigacaoControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import Timeline from "../../../Timeline";
import TimelineItem from "../../../Timeline/TimelineItem";
import OrSpinner from "../../../Utils/OrSpinner";
import VerLigacao from "./VerLigacao";

interface IComponenteHistoricoLigacoesProps {
    idConta: number,
    height?: number
}

export default function ComponenteHistoricoLigacoes(props: IComponenteHistoricoLigacoesProps) {

    const {
        value: lstHistoricoLigacoes,
        loading
    } = useAsyncEffect(async () => {
        return ListarHistoricoLigacoesController(props.idConta)
    }, [props.idConta])


    return (
        <OrSpinner loading={loading} spinner="capys">
            <div className="historico-container" style={{
                height: props.height ?? 400
            }}>
                <Timeline
                    itemList={lstHistoricoLigacoes ?? []}
                    keyGetter={hl => hl.ID_LIGACAO}
                    noDataIndication="Nenhuma ligação registrada"
                >
                    {
                        ligacao => (
                            <TimelineItem
                                date={new Date(ligacao.DT_LIGACAO)}
                                iconColor="info"
                                title={ligacao.DS_USUARIO}
                                iconTooltipText="Ligação"
                                icon={faHeadphones}
                            >
                                <VerLigacao ID_CONTA_LIGACAO={ligacao.ID_CONTA_LIGACAO} />
                            </TimelineItem>
                        )
                    }
                </Timeline>
            </div>
        </OrSpinner>
    )
}